import ajax from "../../../authenticationSafeAjax";

const AUTH_API_URL = "/disclosure/api/auth";
const LOGOUT_API_URL = "/disclosure/api/auth/logout";

export function requestAuthenticationStatus(callback) {
    ajax({ url: AUTH_API_URL }, (code, response) => {
        const authenicationStatus = JSON.parse(response);
        callback(authenicationStatus);
    });
}

export function requestLogout(callback) {
    ajax({ url: LOGOUT_API_URL, method: 'POST' }, (code, response) => {
        callback();
    });
}


/** WEBPACK FOOTER **
 ** ./src/main/javascript/disclosure/authentication/actions/authenticationRequests.js
 **/